import DynamicMap from "components/maps/DynamicMap/DynamicMap";

import "mapbox-gl/dist/mapbox-gl.css";

import styles from "./Map.module.scss";

export default function Map({ data, geoJSON, latLng, resize, children, zoom }) {
  return (
    <DynamicMap
      lat={latLng?.lat ?? 0}
      lng={latLng?.lng ?? 0}
      zoom={zoom}
      geoJSON={geoJSON}
      showMarkers={false}
      destinationData={data.destinations}
      resize={resize}
      projection="mercator"
    >
      {children}
    </DynamicMap>
  );
}
